import { useCallback, useEffect } from "react"
import { subscriptionService } from "../../../data/services/subscriptionService"
import { useApiStatus } from "../../../common/hooks/useApiStatus"
import { transformFormDataToObjectives } from "../../../data/utility/objectivesUtils"
import { getOfferPrice, getOfferPricing } from "../newSubscriptionUtils"
import { useNewSubscriptionStepper } from "../../../common/hooks/subscription/useNewSubscriptionStepper"

export const useGenerateCheckoutSession = ({
    isLoading,
    plan,
    apiRequest,
    email,
    schoolSubjects,
    setCheckoutSession,
    pricingTable,
    sessionsPerWeek,
}) => {
    const { calculateFirstMonthHours } = useNewSubscriptionStepper()

    const generateCheckoutSession = useCallback(() => {
        const offerPricing = getOfferPricing({
            pricingTable,
            offerType: plan.offerType,
            sessionsPerWeek,
            withCommitment: plan.withCommitment,
        })
        const { hoursPerMonth, hourlyPrice } = getOfferPrice({
            offerPricing,
            hoursPerWeek: plan.hoursPerWeek,
        })
        const firstMonthHours = calculateFirstMonthHours(
            plan.startDate,
            hoursPerMonth
        )

        const objectives = transformFormDataToObjectives(
            {
                desiredSupport: "Soutien sur une ou plusieurs matières",
                prioritizedSchoolSubjects: plan.subjectIds,
                subjectHoursAllocation: plan.hoursAllocation,
            },
            plan.hoursPerWeek,
            schoolSubjects
        )

        apiRequest(
            subscriptionService.selfCreateSubscription,
            {},
            {
                email,
                offer_type: plan.offerType,
                hours_per_month: hoursPerMonth,
                with_commitment: plan.withCommitment,
                ttc_price: hourlyPrice,
                needs_tutorial: false,
                objectives,
                starts_at: plan.startDate + " 08:00:00",
                desired_support: "Soutien sur une ou plusieurs matières",
                first_month_hours: firstMonthHours,
            }
        )
    }, [plan])
    useApiStatus(
        subscriptionService.selfCreateSubscription,
        null,
        true,
        (data) => setCheckoutSession(data)
    )

    useEffect(() => {
        if (isLoading) return

        generateCheckoutSession()
    }, [generateCheckoutSession, isLoading])
}
